import React from 'react';

export function Cookies() {
    return (
        <div className="min-h-screen bg-background py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto prose dark:prose-invert">
                <h1 className="text-3xl font-bold text-foreground mb-8">Cookie Policy</h1>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">1. What Are Cookies</h2>
                    <p className="text-muted-foreground mb-4">
                        Cookies are small text files that are used to store small pieces of information. They are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, make it more secure, provide better user experience, and understand how the website performs and to analyze what works and where it needs improvement.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">2. How We Use Cookies</h2>
                    <p className="text-muted-foreground mb-4">
                        As most of the online services, our website uses first-party and third-party cookies for several purposes. First-party cookies are mostly necessary for the website to function the right way, and they do not collect any of your personally identifiable data.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">3. Types of Cookies We Use</h2>
                    <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                        <li><strong>Essential:</strong> Some cookies are essential for you to be able to experience the full functionality of our site. For example, staying logged in.</li>
                        <li><strong>Statistics:</strong> These cookies store information like the number of visitors to the website, the number of unique visitors, which pages of the website have been visited, the source of the visit, etc.</li>
                        <li><strong>Functional:</strong> These are the cookies that help certain non-essential functionalities on our website. These functionalities include embedding content like videos or sharing content of the website on social media platforms.</li>
                    </ul>
                </section>

                <div className="pt-8 border-t border-border">
                    <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
}
